module.exports = __webpack_public_path__ + "img/video-en-1.a874cb1.jpg";